module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/adengiMobile-cb28d646e5223232e90b86ee5ed5082a.png";